var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAdsk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-805db460-3655-4e2f-8094-c8c23fe99534",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-3e8cc171-e9b7-4fe5-a680-f2f371351135{fill:#fff;}.uuid-eef48ee7-96e8-4d0d-af43-afec312e68f1{fill:url(#uuid-dec873d5-278b-4f08-ac98-fec09cd8cf0d);}.uuid-eefd4978-4723-4716-bf0e-17b12e2a8291{fill:url(#uuid-e874100f-31a0-41c8-924c-2ebc0a37f298);}.uuid-44bb75ea-be15-4f60-9a2e-d99eec34b531{fill:url(#uuid-7cdc36ba-43b6-46dd-a283-74c4ff53e1a7);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-e874100f-31a0-41c8-924c-2ebc0a37f298",
    x1: 148.45,
    y1: 4914.84,
    x2: 292.9,
    y2: 4944.27,
    gradientTransform: "translate(0 5252.52) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b7a77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4ebaa9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5cc2b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-7cdc36ba-43b6-46dd-a283-74c4ff53e1a7",
    x1: 225.16,
    y1: 5104.82,
    x2: 156.05,
    y2: 4938.83,
    gradientTransform: "translate(0 5252.52) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#236736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#6ba443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86c146"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-dec873d5-278b-4f08-ac98-fec09cd8cf0d",
    x1: 244.12,
    y1: 5120.95,
    x2: 345.67,
    y2: 4873.6,
    gradientTransform: "translate(0 5252.52) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29a5e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#356eb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#394da5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-3e8cc171-e9b7-4fe5-a680-f2f371351135",
    d: "m-.5-.5h513v513H-.5V-.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-eefd4978-4723-4716-bf0e-17b12e2a8291",
    d: "m177.38,375.09c-7.2,0-10.95-2.66-14.54-8.82l-32.8-59.45c-2.26-4.26-2.3-5.68-2.3-8.75l51.56,2.22,12.57,10.68h100.77l-83.99,52.86c-4.19,2.43-20.1,11.27-31.27,11.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-44bb75ea-be15-4f60-9a2e-d99eec34b531",
    d: "m191.88,310.96h-45.8c-13.47,0-18.32-6.03-18.32-12.9,0-4.35,1.43-6.72,3.41-11.55l64.99-151.69.7-1.33.9-1.37,1.88-1.78,2.75-1.43,3.98-.86,6.84.17,45.15,16.42-15.27,47.09-51.19,119.24Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-eef48ee7-96e8-4d0d-af43-afec312e68f1",
    d: "m320.12,375.09l-100.61-237.45c-1.77-4.03-4.6-9.25-11.94-9.25-6.55,0-9.66,3.1-11.43,6.43.92-2.4,3.66-7.07,11.66-7.07h70.79c6.52,0,9.66,3.76,11.08,7.19l103.73,240.15h-73.29Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdsk);
export default __webpack_public_path__ + "static/media/icon_adsk.aa84969cbc3ca01b551242959485e780.svg";
export { ForwardRef as ReactComponent };